export interface MergeCsvOption {
  sheet_name?: string;
  position?: number;
  include?: boolean;
  uid?: string;
}

export interface SheetNameValidationResult {
  hasErrors: boolean;
  duplicates: Set<string>;
  tooLong: Set<string>;
}

export const validateSheetNames = (options: MergeCsvOption[]): SheetNameValidationResult => {
  const names = options
    .filter(opt => opt.include !== false)
    .map(opt => opt.sheet_name?.trim() || "");

  const seen = new Set<string>();
  const duplicates = new Set<string>();
  const tooLong = new Set<string>();

  names.forEach(name => {
    if (seen.has(name)) duplicates.add(name);
    seen.add(name);
    if (name.length > 31) tooLong.add(name);
  });

  return {
    hasErrors: duplicates.size > 0 || tooLong.size > 0 || names.includes(""),
    duplicates,
    tooLong,
  };
};
